/**
 * Workflows — automation sequences, listed with their live counters.
 *
 * Activation is guarded: a workflow without a trigger segment has no audience
 * to enrol, so the backend refuses it and the button explains why.
 */
define('mailingWorkflowsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  App,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var WorkflowsView = Marionette.ItemView.extend({

    className: 'mailing-page mailing-workflows',

    template: _.template(
      '<%= nav %>' +
      '<div class="mlg-body"><div class="mlg-loading">Loading workflows…</div></div>' +
      '<div class="mlg-modal" style="display:none"></div>'
    ),

    ui: {
      body: '.mlg-body',
      modal: '.mlg-modal'
    },

    events: {
      'click .mlg-new-workflow': 'onNew',
      'click .mlg-open': 'onOpen',
      'click .mlg-activate': 'onActivate',
      'click .mlg-pause': 'onPause',
      'click .mlg-delete': 'onDelete',
      'click .mlg-modal-cancel': 'closeModal',
      'click .mlg-modal-save': 'onCreate'
    },

    serializeData: function () {
      return {
        nav: Shell.navHtml('workflows',
          '<button type="button" class="mlg-btn primary mlg-new-workflow">New workflow</button>')
      };
    },

    onShow: function () {
      this.load();
    },

    load: function () {
      var self = this;
      MailingApi.workflows().done(function (workflows) {
        self.renderList(workflows || []);
      }).fail(function (xhr) {
        self.ui.body.html('<div class="mlg-error">' + _.escape(MailingApi.errorMessage(xhr)) + '</div>');
      });
    },

    renderList: function (workflows) {
      if (!workflows.length) {
        this.ui.body.html(Shell.emptyHtml(
          'No workflow yet. A workflow follows each contact of a segment through a sequence of waits, ' +
          'emails and conditions.'));
        return;
      }
      var rows = _.map(workflows, function (workflow) {
        var status = workflow.status || 'DRAFT';
        return '<tr data-secid="' + workflow.secId + '">' +
          '<td class="c-name"><a class="mlg-open" href="#mailing/workflows/' + workflow.secId + '">' +
            _.escape(workflow.name || '(untitled)') + '</a></td>' +
          '<td><span class="mlg-chip st-' + status.toLowerCase() + '">' +
            Shell.prettyCase(status) + '</span></td>' +
          '<td>' + _.escape(workflow.segmentName || '— no segment —') + '</td>' +
          '<td class="num">' + Shell.formatNumber(workflow.enrolledCount) + '</td>' +
          '<td class="num">' + Shell.formatNumber(workflow.completedCount) + '</td>' +
          '<td class="num">' + Shell.formatNumber(workflow.emailsSent) + '</td>' +
          '<td class="c-actions">' +
            (status === 'ACTIVE' ?
                '<button type="button" class="mlg-btn small mlg-pause">Pause</button>' :
                '<button type="button" class="mlg-btn small primary mlg-activate">Activate</button>') +
          '  <button type="button" class="mlg-btn small danger mlg-delete">Delete</button>' +
          '</td></tr>';
      }).join('');

      this.ui.body.html(
        '<table class="mlg-table">' +
        '<thead><tr><th>Workflow</th><th>Status</th><th>Trigger segment</th>' +
        '<th class="num">Enrolled</th><th class="num">Completed</th><th class="num">Emails</th><th></th>' +
        '</tr></thead><tbody>' + rows + '</tbody></table>');
    },

    onNew: function () {
      this.ui.modal.html(
        '<div class="mlg-modal-card narrow">' +
        '<h3>New workflow</h3>' +
        '<label>Name<input type="text" class="f-name"></label>' +
        '<div class="mlg-hint">You pick the trigger segment and build the steps on the next screen.</div>' +
        '<div class="mlg-modal-actions">' +
        '  <button type="button" class="mlg-btn mlg-modal-cancel">Cancel</button>' +
        '  <button type="button" class="mlg-btn primary mlg-modal-save">Create</button>' +
        '</div>' +
        '</div>').show();
    },

    onCreate: function () {
      var self = this;
      var name = this.ui.modal.find('.f-name').val();
      if (!name) {
        Shell.banner(this.$el, 'Name is required', 'error');
        return;
      }
      MailingApi.createWorkflow({ name: name, steps: '[]' }).done(function (workflow) {
        self.closeModal();
        App.navigate('mailing/workflows/' + workflow.secId, { trigger: true });
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onActivate: function (e) {
      var self = this;
      MailingApi.activateWorkflow(this.secIdOf(e)).done(function () {
        Shell.banner(self.$el,
          'Workflow activated — matching contacts are enrolled within five minutes', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onPause: function (e) {
      var self = this;
      MailingApi.pauseWorkflow(this.secIdOf(e)).done(function () {
        Shell.banner(self.$el,
          'Workflow paused — no new enrolments, and contacts already inside stop advancing', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onDelete: function (e) {
      var self = this;
      var name = $(e.currentTarget).closest('tr').find('.c-name a').text();
      if (!window.confirm('Delete "' + name + '"? Enrolments and their history go with it.')) { return; }

      MailingApi.deleteWorkflow(this.secIdOf(e)).done(function () {
        Shell.banner(self.$el, 'Workflow deleted', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onOpen: function (e) {
      e.preventDefault();
      App.navigate($(e.currentTarget).attr('href').substring(1), { trigger: true });
    },

    closeModal: function () {
      this.ui.modal.hide().empty();
    },

    secIdOf: function (e) {
      return $(e.currentTarget).closest('tr').data('secid');
    }
  });

  module.exports = WorkflowsView;
});

